export const MODAL_ENABLE_STARTER_OPEN = 'MODAL_ENABLE_STARTER_OPEN';
export const MODAL_ENABLE_STARTER_CLOSE = 'MODAL_ENABLE_STARTER_CLOSE';


export const VECHICLE_STATUS_SAVE_BULK_CHANGE_STARTER = 'VECHICLE_STATUS_SAVE_BULK_CHANGE_STARTER';
export const VECHICLE_STATUS_SAVE_BULK_CHANGE_STARTER_RESULT = 'VECHICLE_STATUS_SAVE_BULK_CHANGE_STARTER_RESULT';
export const VECHICLE_STATUS_SAVE_BULK_CHANGE_STARTER_PROGRESS = 'VECHICLE_STATUS_SAVE_BULK_CHANGE_STARTER_PROGRESS';
export const SHOW_HIDE_ENABLE_DISABLE_STARTER_MODAL = 'SHOW_HIDE_ENABLE_DISABLE_STARTER_MODAL';
